import { useIsFetching } from '@tanstack/react-query';
import { ThinLoadingBar } from './loading';

export function RefreshingIndicator() {
  const isFetching = useIsFetching();

  if (!isFetching) {
    return null;
  }

  return <ThinLoadingBar />;
}
